import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ProjectAdmin from "../views/projectAdmin/index.vue";
import AccountChecking from "../views/accountChecking/index.vue";
import retureBoard from "../views/retureBoard";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'child',
    component: Home,
    children: [
      {
        path: '/projectAdmin/index',
        name: 'ProjectAdmin',
        component: ProjectAdmin,
      },
      {
        path: "/retureBoard/index",
        name: "retureBoard",
        component: retureBoard,
        mate: { title: "退费数据统计" },
      },
      {
        path: '/accountChecking/index',
        name: 'AccountChecking',
        component: AccountChecking
      }
    ]
  },
  {
    path: "/groupActivities/admin",
    name: "groupActivitiesAdmin",
    component: () => import('@/views/groupActivities/Admin')
  },
  {
    path: "/groupActivities/classification",
    name: "groupActivitiesclassification",
    component: () => import('@/views/groupActivities/classification')
  },
  {
    path: "/groupActivities/data",
    name: "groupActivitiesdata",
    component: () => import('@/views/groupActivities/data')
  },
  {
    path: "/groupActivities/order",
    name: "groupActivitiesorder",
    component: () => import('@/views/groupActivities/order')
  },
  // 退费数据二期 -- 退费周期
  {
    path: "/refundStatistic/period",
    name: "period",
    component: () => import('@/views/refundStatistic/period')
  },
  // 退费数据二期 -- 产品退费数据
  {
    path: "/refundStatistic/skuRefund",
    name: "skuRefund",
    component: () => import('@/views/refundStatistic/skuRefund')
  },
  // 退费数据二期 -- 退费基础数据
  {
    path: "/refundStatistic/basicData",
    name: "basicData",
    component: () => import('@/views/refundStatistic/basicData')
  },
  // 退费数据二期 -- 服务支持审核数据
  {
    path: "/refundStatistic/auditData",
    name: "auditData",
    component: () => import('@/views/refundStatistic/auditData')
  },
  // 基础
  {
    path: '/seasonActivities/season',
    name: 'season',
    component: () => import('@/views/seasonActivities/season')
  },
  {
    path: '/seasonActivities/team',
    name: 'team',
    component: () => import('@/views/seasonActivities/team')
  },
  // 赛季活动 -- PK管理
  {
    path: '/seasonActivities/PKManagement',
    name: 'PKManagement',
    component: () => import('@/views/seasonActivities/PKManagement')
  },
  // 赛季活动 -- 通知配置
  {
    path: '/seasonActivities/message',
    name: 'message',
    component: () => import('@/views/seasonActivities/message')
  },
  // vip
  {
    path: '/seasonVipActivities/season',
    name: 'season',
    component: () => import('@/views/seasonVipActivities/season')
  },
  {
    path: '/seasonVipActivities/team',
    name: 'team',
    component: () => import('@/views/seasonVipActivities/team')
  },
  // 赛季活动 -- PK管理
  {
    path: '/seasonVipActivities/PKManagement',
    name: 'PKManagement',
    component: () => import('@/views/seasonVipActivities/PKManagement')
  },
  // 赛季活动 -- 通知配置
  {
    path: '/seasonVipActivities/message',
    name: 'message',
    component: () => import('@/views/seasonVipActivities/message')
  },
  // 投放小程序 -- 渠道码管理
  {
    path: '/tfMiniapp/index',
    name: 'channel',
    component: () => import('@/views/tfMiniapp')
  },
  // 视频备考通 -- 科目展示
  {
    path: '/videoReference/account/index',
    name: 'videoReferenceAccount',
    component: () => import('@/views/videoReference/account/index.vue')
  },
  // 视频备考通 -- 公开课管理
  {
    path: '/videoReference/regulate/index',
    name: 'videoReferenceRegulate',
    component: () => import('@/views/videoReference/regulate/index.vue')
  },
  // 视频备考通 -- 视频管理
  {
    path: '/videoReference/videoAdmin/index',
    name: 'videoReferenceVideoAdmin',
    component: () => import('@/views/videoReference/videoAdmin/index.vue')
  },
  // 视频备考通 -- 公开课海报
  {
    path: '/videoReference/poster/index',
    name: 'videoReferencePoster',
    component: () => import('@/views/videoReference/poster/index.vue')
  },
  // 视频备考通 -- 我的用户
  {
    path: '/videoReference/user/index',
    name: 'videoReferenceUser',
    component: () => import('@/views/videoReference/user/index.vue')
  },
  // 视频备考通 -- 用户管理
  {
    path: '/videoReference/userAdmin/index',
    name: 'videoReferenceUserAdmin',
    component: () => import('@/views/videoReference/userAdmin/index.vue')
  },
  // 项目业绩数据看板
  {
    path: '/salesWorkbench/projectDataboard/index',
    name: 'salesWorkbenchprojectDataboard',
    component: () => import('@/views/salesWorkbench/projectDataboard/index.vue')
  },
  // 孵化组业绩看板
  {
    path: '/salesWorkbench/incubatorDateboard',
    name: 'IncubatorDateboardDataboard',
    component: () => import('@/views/salesWorkbench/incubatorDateboard/index.vue')
  },
  // 孵化组业绩看板
  {
    path: '/incubatorManage',
    name: 'IncubatorManage',
    component: () => import('@/views/incubatorManage/index.vue')
  },
  // riskgo风控处理
  {
    path: '/riskgo',
    name: 'riskgo',
    component: () => import('@/views/riskgo/index.vue')
  },
  // 微信riskgo风控处理
  {
    path: '/wechatRiskgo',
    name: 'WechatRiskgo',
    component: () => import('@/views/wechatRiskgo/index.vue')
  },
  // 支付宝交易支付投诉处理
  // {
  //   path: '/alipayRiskgo',
  //   name: 'AlipayRiskgo',
  //   component: () => import('@/views/alipayRiskgo/index.vue')
  // },
  // 全媒体账号管理
  {
    path: '/bootcamp',
    name: 'Bootcamp',
    component: () => import('@/views/bootcamp/index.vue')
  },
  // 销售活码
  {
    path: '/saleQrcode',
    name: 'SaleQrcode',
    component: () => import('@/views/salesQrcode/index.vue')
  },
  // 销售活码 - 关联管理
  {
    path: '/saleQrcodeRelevanceManage',
    name: 'SaleQrcode',
    component: () => import('@/views/salesQrcode/relevanceManage.vue')
  }
]

const router = new VueRouter({
  mode: "history",
  base: window.__POWERED_BY_QIANKUN__ ? "/app1" : process.env.BASE_URL,
  routes,
});

export default router;
